import React from 'react';

import { AccessUnavailable } from '../components/molecules/AccessUnavailable/AccessUnavailable';

type AppRoute = {
  path: string;
  component: React.ReactNode;
  isMenuSidebarItem?: boolean;
  isMenuHeaderItem?: boolean;
  isMenuHeaderMobileItem?: boolean;
  [key: string]: unknown;
};

/**
 * As rotas de módulo que a conta NÃO tem, prontas para entrar no roteador com um estado
 * de acesso indisponível.
 *
 * O MainContent monta um <Route> por rota liberada e mais nada: um endereço conhecido
 * mas fora das permissões não casava com <Route> nenhum, e a área de conteúdo ficava em
 * branco — sem mensagem e sem redirecionamento (MV2-1821). O guarda do AppRouter também
 * não pega: ele só manda para /not-found o endereço que não existe em staticRoutes, e
 * /interoperability existe.
 *
 * Só as entradas de menu (isMenuSidebarItem): são as portas de entrada dos módulos, o que
 * alguém digita ou recebe por link. As telas internas com :id ficam de fora de propósito —
 * lá o endereço sozinho não diz nada, e casar rota com parâmetro aqui arriscaria responder
 * por cima de uma rota liberada.
 *
 * Os flags de menu vão FALSE: a Sidebar e o Header montam o menu a partir desta mesma
 * lista, e o módulo que a conta não tem não pode aparecer lá. A rota entra apenas para ter
 * o que responder a quem chega pelo endereço.
 */
export const accessDeniedRoutes = (
  allRoutes: AppRoute[],
  allowedRoutes: (AppRoute | false | null | undefined)[],
): AppRoute[] => {
  const allowed = new Set(
    (allowedRoutes || []).filter(Boolean).map((route) => (route as AppRoute).path),
  );

  return allRoutes
    .filter(({ path, isMenuSidebarItem }) => isMenuSidebarItem && !allowed.has(path))
    .map((route) => ({
      ...route,
      component: <AccessUnavailable />,
      isMenuSidebarItem: false,
      isMenuHeaderItem: false,
      isMenuHeaderMobileItem: false,
    }));
};
